module.exports = __webpack_public_path__ + "media/images/debt_consol_icon_active-72d5691d.svg";